//@flow

type Options = {
    element: HTMLElement,
    timeout: number,
    onReset: ()=>void,
};

function performBindings(_this: Object, objKeys: Array<string>){
    objKeys.forEach( (objKey) => {
        _this[objKey] = _this[objKey].bind(_this);
    });
}

// Takes in a document to listen for user events, and a url to load when timeout has passed
export default class AutoReset {
    _lastInteractionTimestamp: number;
    _intervalId: ?IntervalID;
    checkInterval: number;
    options: Options;
    started: boolean;


    constructor( options: Options ){
        this.options = options;
        if(!options.element){ throw new Error("AutoReset: No HTML element specified in options"); }
        if(!options.timeout){ throw new Error("AutoReset: No timeout specified in options"); }
        if(!options.onReset){ throw new Error("AutoReset: No onReset function specified in options"); }

        this._intervalId = null;
        this.checkInterval = 1000; // How often to check, in millisseconds
        this.started = false;
        this._lastInteractionTimestamp = this._getCurrentTimestamp();

        // Bindings
        performBindings(this, ['_checkIfShouldReset', 'onInteractionEvent', 'start']);

        this._addEventListeners();
    }

    _addEventListeners(){
        this.options.element.addEventListener('click', () => {
            this.onInteractionEvent();
        });
        this.options.element.addEventListener('mousedown', () => {
            this.onInteractionEvent();
        });
        this.options.element.addEventListener('touchstart', () => {
            this.onInteractionEvent();
        });
        this.options.element.addEventListener('keydown', () => {
            this.onInteractionEvent();
        });
        this.options.element.addEventListener('mousemove', () => {
            this.onInteractionEvent();
        });
    }

    _getCurrentTimestamp(): number{
        return (new Date()).valueOf(); // Returns a timestamp in milliseconds?
    }

    start (){
        this.started = true;
        this._intervalId = setInterval(this._checkIfShouldReset, this.checkInterval); //Run the condition check every so often
    }

    onInteractionEvent(){
        this._lastInteractionTimestamp = this._getCurrentTimestamp();

        if( !this.started ){
            this.start();
        }
    }

    _checkIfShouldReset(){
        var diff = this._getCurrentTimestamp() - this._lastInteractionTimestamp;
        if(diff > this.options.timeout * 1000){
            if(this._intervalId){
                this._intervalId && clearInterval(this._intervalId);
                this._intervalId = null;
                this.started = false;

                this.options.onReset();
            }
        }
    }

}


// WEBPACK FOOTER //
// src/kiosk/AutoReset/index.js